// client/src/routes/app/fiscal/calendar.tsx — SCR-FISC-002 · FISC-007 (04 §8.11, §9.2.3).
//
// Replaces UI-003's `PlaceholderScreen`, which named this item as its owner.
//
// The window and the four filters are URL state, because they are the endpoint's own query:
// a link to „declarațiile din martie" survives a refresh and Back steps the window back. The
// drawer of SCR-FISC-007 rides here too — §8.11 makes it addressable „on any route".
//
// Both gates, for the reason `index.tsx` gives: the permission is the API's, the role is
// §8.11's heading (D-1271).

import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';

import { RequireAnyRole, RequirePermission } from '@/components/layout/route-guards';
import { fiscalVisible } from '@/config/fiscal';
import { FiscalCalendarScreen } from '@/features/fiscal/FiscalCalendarScreen';
import { fiscalCalendarSearchSchema, type FiscalCalendarSearch } from '@/features/fiscal/search';

export const Route = createFileRoute('/app/fiscal/calendar')({
  // Withdrawn from view with the fiscal module (D-2780); see `fiscal/index.tsx`.
  beforeLoad: () => {
    if (!fiscalVisible()) throw redirect({ to: '/app/dashboard' });
  },
  validateSearch: fiscalCalendarSearchSchema,
  component: FiscalCalendarRoute,
});

function FiscalCalendarRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Fiscal.Read">
      <RequireAnyRole roles={['owner', 'accountant']}>
        <FiscalCalendarScreen
          search={search}
          onSearchChange={(next: (previous: FiscalCalendarSearch) => FiscalCalendarSearch) => {
            void navigate({ search: next });
          }}
        />
      </RequireAnyRole>
    </RequirePermission>
  );
}
